/**
 * NASA pays by credit card. NASA COMET jobs (billed through Amentum Comet) are
 * Net 45 like every other customer.
 */
export function customerPaysByCreditCard(
  customerName?: string | null
): boolean {
  const name = String(customerName ?? "").trim();
  return /\bnasa\b/i.test(name) && !/\bcomet\b/i.test(name);
}
